export default "__VITE_ASSET__pwvam0iY__"